import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { IntakeForm } from 'src/API';
import { IntakeFormService } from 'src/app/intake-form/intake-form.service';

@Injectable({
  providedIn: 'root'
})
export class IntakeFormResolver implements Resolve<IntakeForm> {
  constructor(private intakeFormService: IntakeFormService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<IntakeForm> {
    const intakeFormId = route.paramMap.get('id');
    return this.intakeFormService.getIntakeForm(intakeFormId);
  }
}
